import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Button } from '@eds-web/react';
import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled';

import { StyledPrizeContainer } from './Prizes.style';
import { StepComponentProps } from './PrizeStep';
import { PRIZE_V2_ROUTER } from '../../routes/routes';
import { device } from '../../constants/breakpoint';

const MobileButtonContainer = styled.div`
    display: none;
    @media screen and ${device.laptop} {
        display: flex;
        justify-content: center;
        margin-top: 24px;
        button {
            width: 100%;
        }
    }
`;

const ContentContainer = styled.div`
    gap: 16px;
    display: flex;
    flex-direction: column;
    padding-top: 32px;
`;

export const Step2: React.FC<StepComponentProps> = ({}) => {
    const { t } = useTranslation();
    const history = useHistory();

    const handleBack = useCallback(() => {
        history.replace({
            pathname: PRIZE_V2_ROUTER
        });
    }, [history]);

    const getTitle = () => {
        return t('epic.esport.step2.content.title');
    };

    const getContent = () => {
        return t('epic.esport.step2.content');
    };

    return (
        <>
            <StyledPrizeContainer>
                <ContentContainer>
                    <Text variant="headingMD">{getTitle()}</Text>
                    <Text variant="paragraphMD" color="primary">
                        {getContent()}
                    </Text>
                </ContentContainer>
            </StyledPrizeContainer>
            <MobileButtonContainer>
                <Button onClick={handleBack} size="lg" variant="solid">
                    {t('epic.esport.actions.back')}
                </Button>
            </MobileButtonContainer>
        </>
    );
};
